import { useState } from 'react';
import { Modal, Radio, Space, Typography, message } from 'antd';
import { FileImageOutlined, FilePdfOutlined, FileWordOutlined } from '@ant-design/icons';
import type { TenantOrder } from '@/mocks/orders';
import { exportOrderCustomerDoc, type OrderCustomerDocFormat } from '../utils/exportOrderCustomerDoc';

const FORMAT_OPTIONS: Array<{ value: OrderCustomerDocFormat; label: string; hint: string; icon: JSX.Element }> = [
  { value: 'pdf', label: 'PDF', hint: 'Khổ A4, in hoặc gửi email', icon: <FilePdfOutlined style={{ color: '#cf1322' }} /> },
  { value: 'image', label: 'Ảnh', hint: '1 ảnh PNG toàn bộ đơn — tiện gửi Zalo', icon: <FileImageOutlined style={{ color: '#237804' }} /> },
  { value: 'word', label: 'Word', hint: 'File .docx, sửa lại được trước khi gửi', icon: <FileWordOutlined style={{ color: '#0958d9' }} /> },
];

interface Props {
  order: TenantOrder | null;
  onClose: () => void;
}

/** TCR-1962 — chọn định dạng rồi tải tài liệu "ĐƠN HÀNG" về máy để gửi khách. */
export function SendToCustomerModal({ order, onClose }: Props) {
  const [format, setFormat] = useState<OrderCustomerDocFormat>('pdf');
  const [loading, setLoading] = useState(false);

  const handleDownload = async () => {
    if (!order) return;
    setLoading(true);
    try {
      await exportOrderCustomerDoc(order, format);
      message.success('Đã tải tài liệu đơn hàng');
      onClose();
    } catch (e: unknown) {
      message.error((e as Error)?.message || 'Tải tài liệu đơn hàng thất bại');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={order != null}
      title={`Gửi cho khách — đơn ${order?.order_number ?? ''}`}
      okText="Tải về"
      cancelText="Đóng"
      onOk={handleDownload}
      onCancel={onClose}
      confirmLoading={loading}
      destroyOnClose
    >
      <Typography.Paragraph type="secondary">
        Chọn định dạng tài liệu “Đơn hàng” để tải về máy, sau đó gửi cho khách qua Zalo, email…
      </Typography.Paragraph>
      <Radio.Group value={format} onChange={(e) => setFormat(e.target.value)}>
        <Space direction="vertical">
          {FORMAT_OPTIONS.map((opt) => (
            <Radio key={opt.value} value={opt.value}>
              <Space size={6}>
                {opt.icon}
                <b>{opt.label}</b>
                <Typography.Text type="secondary">— {opt.hint}</Typography.Text>
              </Space>
            </Radio>
          ))}
        </Space>
      </Radio.Group>
    </Modal>
  );
}
